import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PUBLIC_PATHS = [
  "/",
  "/home",
  "/privacy",
  "/terms",
  "/risk-disclosure",
  "/refund-policy",
  "/contact",
  "/about",
];

const SRC = "https://embed.tawk.to/6a958e0fe91562344c0ab900/1k1c35r86";

// Module-level: resets on a full page load, which is exactly what we want.
let injected = false;

const inject = () => {
  if (injected || document.getElementById("tawk-embed")) return;
  injected = true;
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();
  const s = document.createElement("script");
  s.id = "tawk-embed";
  s.async = true;
  s.src = SRC;
  s.charset = "UTF-8";
  document.body.appendChild(s);
};

// The Tawk client keeps a live visitor session once loaded, so hiding it is not enough.
// On a private route we force one full reload, after which the script is never injected.
export const TawkGate = () => {
  const { pathname, search, hash } = useLocation();
  const isPublic =
    PUBLIC_PATHS.includes(pathname.replace(/\/+$/, "") || "/") &&
    !localStorage.getItem("strictrr_session");

  useEffect(() => {
    if (isPublic) {
      inject();
    } else if (injected) {
      injected = false;
      window.location.replace(`${pathname}${search}${hash}`);
    }
  }, [isPublic, pathname, search, hash]);

  return null;
};
